import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY_REPORT } from "./apiRoutes";

interface UseGetPropertyReportOutstandingProps {
  propertyId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyReportOutstanding = async (propertyId: string) =>
  await axiosAuth.get(`${PROPERTY_REPORT}/${propertyId}/outstanding-dues`);

const useGetPropertyReportOutstanding = ({
  propertyId,
  queryParams,
}: UseGetPropertyReportOutstandingProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-report-outstanding"],
    queryFn: () => getPropertyReportOutstanding(propertyId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyReportOutstanding;
